class ArticleAd extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.dataset.productHandle;
    this.articleHandle = location.pathname
      .split("/")
      .filter((item) => item.length)
      .pop();
    this.campaign = this.dataset.campaign;

    if (this.productHandle) {
      this.loadAd();
    }
  }

  loadAd() {
    fetch(`/products/${encodeURIComponent(this.productHandle.trim())}?view=ad`, { method: "GET" })
      .then((response) => {
        // Not found or server error → no ad
        if (!response.ok) return;
        // Product deleted and redirected to a collection/blog/home → no ad
        if (response.redirected && !new URL(response.url).pathname.startsWith("/products/")) return;
        return response.text();
      })
      .then((res) => {
        if (!res) return;
        // Safety net: never insert a complete page, only the ad snippet
        if (/<html[\s>]|<!doctype/i.test(res) || !res.includes("product-ad")) return;
        this.innerHTML = res;
        const firstLink = this.querySelector("a");
        if (!firstLink) return;
        const href = firstLink.href;
        Array.from(this.querySelectorAll("a")).forEach(
          (link) => (link.href = `${href}`)
        );
      })
      .catch(() => {});
  }
}

if (!customElements.get("article-ad")) {
  customElements.define("article-ad", ArticleAd);
}